import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MF_EVENTS, } from "@/shared/microfrontend/interfaces/microFrontend";
import React, { useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { encodeParam, replaceAsteriskInAnchor, getLatestUserDetails, checkModeSpecificScopes, } from "@/shared/utils/helpers";
import { createClient } from "graphql-ws";
import JiraIcon from "@/assets/icons/jiraLogo.svg";
import useToastStore from "@/shared/zustand/toastStore";
import LoadingAnimation from "./LoadingAnimation";
import { HOST_MODES } from "@/constants";
import NotFoundAnimation from "@/assets/animations/notfoundAnimation.json";
import { Search, User, ChevronUp, ChevronDown } from "lucide-react";
import Lottie from "react-lottie-player";
import useJiraStore from "@/shared/zustand/jiraModeStore";
import { config } from "@/config";
import useAuthStore from "@/shared/zustand/authStore";
import JiraWelcomeScreen from "./welcomeScreen";
// import { InputText } from 'primereact/inputtext';
import { Calendar, Bug, AlertCircle } from "lucide-react";
import ReactMarkdown from "react-markdown";
import JiraErrorScreen from "./JiraErrorScreen";
import InvalidScopes from "@/components/InvalidScopes";
const JiraModeTool = ({ 
// setIsHostLoaded,
setHostLoadedInfo, }) => {
    const { user } = useAuthStore.getState();
    const mfApi = window.hostMicroFrontendApi;
    const showToast = useToastStore((state) => state.showToast);
    const [query, setQuery] = useState("");
    const [jiraTickets, setJiraTickets] = useState([]);
    // console.log("jiraTickets", jiraTickets);
    const [userEmail, setUserEmail] = useState("");
    const [isFilesFetched, setIsFilesFetched] = useState(false);
    const [isGraphqlError, setIsGraphQlError] = useState(false);
    const [showWelcomeScreen, setShowWelComeScreen] = useState(true);
    const [loading, setLoading] = useState(false); // Add this state to manage loading
    const [showErrorScreen, setShowErrorScreen] = useState(false); // Add this state to manage ErrorScreen
    const scrollContainerRef = useRef(null);
    const [scrollPosition, setScrollPosition] = useState(0);
    const { selectedFiles, setSelectedFiles, addFile, clearSelectedFiles, removeFile, isFileSelected, } = useJiraStore();
    const [selectedPreviewFile, setSelectedPreviewFile] = useState(null);
    const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
    const [hasNeededScope, setHasNeededScope] = useState(null);
    const jiraScopes = "https://www.googleapis.com/auth/cloud-platform";
    const toggleDescription = () => {
        setIsDescriptionExpanded(!isDescriptionExpanded);
    };
    const handleSelectProject = (project, isSelected) => {
        if (isSelected) {
            addFile(project);
        }
        else {
            removeFile(project.id);
        }
    };
    function extractWaitMessage(inputString) {
        const prefix = "WaitMessage: ";
        const startIndex = inputString.indexOf(prefix);
        if (startIndex !== -1) {
            const extractedString = inputString.substring(startIndex + prefix.length);
            return extractedString.replace("WaitMessage: ", "");
        }
        else {
            return "";
        }
    }
    //! AI Call
    const callJiraAgent = async (request, jiraMetadata) => {
        let client = null;
        // setShowWelComeScreen(false); // moved down
        try {
            const replyMessage = "";
            const currentContext = "";
            setIsGraphQlError(false);
            setIsFilesFetched(false);
            setHasNeededScope(null); // reset hasNeededScope
            let latestUser = user;
            if (user) {
                const updatedUser = await getLatestUserDetails(user);
                if (updatedUser) {
                    latestUser = updatedUser;
                }
                else {
                    // If we couldn't get updated user details, continue with existing user
                    console.warn("Could not refresh user details, using existing user data");
                }
            }
            if (latestUser?.provider.scope) {
                const hasScope = checkModeSpecificScopes(latestUser.provider.scope, jiraScopes);
                console.log("printing hasScope for jira", hasScope, latestUser.provider.scope);
                if (!hasScope) {
                    setHasNeededScope("invalid");
                    return;
                }
                else {
                    setHasNeededScope("valid");
                }
            }
            else {
                showToast("warn", "Warning", "User doesnt have provider scopes");
                console.error("User doesnt have provider scopes , user details are", latestUser);
                return;
            }
            // setReplyMessage("");
            const userQuery = request.message;
            const messageId = request.messageId;
            let storedMessageForArtifact;
            let artifactstatus = "";
            const formattedQuery = `User Query: ${userQuery}`;
            const requestId = `requestId-${uuidv4()}`;
            const chatAssistantName = "devjiraagent";
            // console.log("PM assistant : ", chatAssistantName);
            const organizationName = "techolution";
            client = await createClient({
                url: config.VITE_WEBSOCKET_URL ?? "",
            });
            const subscription = client.iterate({
                query: `subscription Subscription($guestSessionId: String!, $sessionId: String!, $name:String!, $organizationName:String!, $aiModel:String!, $prompt:String!, $userName:String!, $userEmailId:String!, $userId:String!, $requestId:String!,$replyMessage:String!,$customPrompt:String, $notificationSessionId:String,$images:String,$customMetaData:JSON) {
          chatStream(guestSessionId: $guestSessionId, sessionId: $sessionId, name:$name, organizationName:$organizationName, aiModel:$aiModel, prompt:$prompt, userName:$userName, userEmailId:$userEmailId, userId:$userId, requestId:$requestId, replyMessage:$replyMessage, customPrompt:$customPrompt, notificationSessionId:$notificationSessionId,images:$images,customMetaData: $customMetaData) {
            continueChatResult {
              isEnd
              thinking_break
              is_orchestrator
              is_agent
              responded_by
              header_message
              confidenceScore
              requestId
              replyMessage
              sessionId
              message {
                citations {
                  citation_number
                  title
                  url
                  description
                  metadata {
                    page_index
                  }
                }
                annotations {
                  citations {
                    citation_number
                    title
                    url
                    description
                    metadata {
                      page_index
                    }
                  }
                  text
                }
                citationDisplayType
                next_query_suggestions {
                  query
                }
                response_type
                content
                id
              }
              resourceId
            }
          }
        }`,
                variables: {
                    guestSessionId: window.location.pathname.split("/chat/")[1] || uuidv4(),
                    sessionId: `${organizationName}-${chatAssistantName}-${uuidv4()}`,
                    name: encodeParam(chatAssistantName),
                    organizationName: encodeParam(`${organizationName}`),
                    aiModel: encodeParam("claude-3.5-sonnet"),
                    chatPreviewId: encodeParam(`techolution-${chatAssistantName}-` + uuidv4()),
                    prompt: encodeParam(formattedQuery),
                    userName: encodeParam(latestUser?.provider.name),
                    userEmailId: encodeParam(latestUser?.email),
                    userId: encodeParam("0804b20a-2414-40c8-afd1-1bf0703e9d6e"),
                    requestId: encodeParam(requestId),
                    replyMessage: replyMessage,
                    // customPrompt: props?.generatedPrompt,
                    notificationSessionId: `chat-session-${uuidv4()}`,
                    images: JSON.stringify([]),
                    customMetaData: {
                        userEmail: latestUser?.provider.email,
                        user_access_token: {
                            token: latestUser?.provider.access_token,
                        },
                        user_refresh_token: {
                            token: latestUser?.provider.refresh_token,
                        },
                        operation: jiraMetadata?.operation || "Retrieve",
                        tickets_json: jiraMetadata?.tickets_json,
                    },
                },
            });
            let event;
            const accordianMessageArray = [];
            for await (event of subscription) {
                // setIsStreaming(true);
                // setRenderDone(false);
                setShowWelComeScreen(false);
                const getAssistantObj = (event, accordianMessageArray) => {
                    const streamedresponse = {
                        role: "assistant",
                        content: "",
                        id: uuidv4(),
                    };
                    //orchestrator is sending message, we initially set it as normal message
                    if (event.data.chatStream.continueChatResult.thinking_break === false &&
                        event.data.chatStream.continueChatResult.is_orchestrator === true &&
                        event.data.chatStream.continueChatResult.isEnd === false) {
                        streamedresponse.content = replaceAsteriskInAnchor(event.data.chatStream.continueChatResult.message.content)?.replace(/WaitMessage: /g, "");
                    }
                    //orchestrator is sending message and thinking break is there, we add it to accordian
                    if (event.data.chatStream.continueChatResult.thinking_break === true &&
                        event.data.chatStream.continueChatResult.is_orchestrator === true &&
                        event.data.chatStream.continueChatResult.isEnd === false) {
                        streamedresponse.content = "";
                        accordianMessageArray.push({
                            responsedata: event.data.chatStream.continueChatResult.message.content,
                            responseFrom: event.data.chatStream.continueChatResult.responded_by,
                            header_message: event.data.chatStream.continueChatResult.header_message,
                            finalResponseStatus: false,
                        });
                    }
                    //orchestrator replied with the final message, this is the final response, no need for accordian
                    if (event.data.chatStream.continueChatResult.thinking_break === false &&
                        event.data.chatStream.continueChatResult.is_orchestrator === true &&
                        event.data.chatStream.continueChatResult.isEnd === true) {
                        // console.log(
                        //   "Third if condition",
                        //   event.data.chatStream.continueChatResult
                        // );
                        streamedresponse.content = replaceAsteriskInAnchor(event.data.chatStream.continueChatResult.message.content)?.replace(/WaitMessage: /g, "");
                    }
                    //agent responded it will directly be shown in collapsed form
                    if (event.data.chatStream.continueChatResult.thinking_break === false &&
                        event.data.chatStream.continueChatResult.is_orchestrator ===
                            false &&
                        event.data.chatStream.continueChatResult.isEnd === false) {
                        // console.log("Fourth if condition", event.data);
                        accordianMessageArray = [
                            ...accordianMessageArray,
                            {
                                responsedata: event.data.chatStream.continueChatResult.message.content,
                                responseFrom: event.data.chatStream.continueChatResult.responded_by,
                                header_message: event.data.chatStream.continueChatResult.header_message,
                                finalResponseStatus: true,
                            },
                        ];
                    }
                    //final response from agent
                    if (event.data.chatStream.continueChatResult.thinking_break === true &&
                        event.data.chatStream.continueChatResult.is_orchestrator ===
                            false &&
                        event.data.chatStream.continueChatResult.isEnd === false) {
                        // console.log("Fifth if condition");
                        if (event.data.chatStream.continueChatResult.header_message ===
                            "Awesome! JIRA tickets are created!") {
                            const resObj = event.data.chatStream.continueChatResult.message.content;
                            const resJson = JSON.parse(event.data.chatStream.continueChatResult.message.content);
                            console.log("[JIRA] Created Response from agent:", resJson);
                            console.log("[JIRA] Created Tickets from agent:", resJson.tickets);
                            setShowErrorScreen(false);
                            setJiraTickets(resJson.tickets);
                            setIsFilesFetched(true);
                            const statusMsgData = {
                                artifactData: {
                                    id: uuidv4(),
                                    artifactTitle: "Artifact: Jira Mode",
                                    artifactData: resJson.tickets, // data which is required for my component to render
                                    modeName: "Jira Mode",
                                },
                            };
                            const statusMessage = {
                                messageType: "success",
                                message: "",
                                data: statusMsgData,
                                messageId: uuidv4(),
                                time: new Date(),
                                isReadyToPersist: true,
                                modeName: "Jira Mode",
                            };
                            storedMessageForArtifact = statusMessage;
                            storedMessageForArtifact;
                            artifactstatus = "true";
                        }
                        if (event.data.chatStream.continueChatResult.header_message ===
                            "Error in JIRA Agent") {
                            setJiraTickets([]);
                            setShowErrorScreen(true);
                        }
                        if (event.data.chatStream.continueChatResult.header_message ===
                            "Awesome! JIRA tickets are retrieved!") {
                            const resObj = event.data.chatStream.continueChatResult.message.content;
                            const resJson = JSON.parse(event.data.chatStream.continueChatResult.message.content);
                            console.log("[JIRA] Response from agent:", resJson);
                            console.log("[JIRA] Tickets from agent:", resJson.tickets);
                            setShowErrorScreen(false);
                            setJiraTickets(resJson.tickets);
                            setIsFilesFetched(true);
                            const statusMsgData = {
                                artifactData: {
                                    id: uuidv4(),
                                    artifactTitle: "Artifact: Jira Mode",
                                    artifactData: resJson.tickets, // data which is required for my component to render
                                    modeName: "Jira Mode",
                                },
                            };
                            const statusMessage = {
                                messageType: "success",
                                message: "",
                                data: statusMsgData,
                                messageId: uuidv4(),
                                time: new Date(),
                                isReadyToPersist: true,
                                modeName: "Jira Mode",
                            };
                            storedMessageForArtifact = statusMessage;
                            storedMessageForArtifact;
                            artifactstatus = "true";
                        }
                        accordianMessageArray.push({
                            responsedata: event.data.chatStream.continueChatResult.message.content,
                            responseFrom: event.data.chatStream.continueChatResult.responded_by,
                            header_message: event.data.chatStream.continueChatResult.header_message,
                            finalResponseStatus: false,
                        });
                    }
                    const annotations = event?.data?.chatStream?.continueChatResult?.message?.annotations;
                    let assistantObj = {
                        role: "assistant",
                        content: streamedresponse.content,
                        orchestratorAndAgentsMessages: accordianMessageArray,
                        time: new Date(),
                        requestId: event.data.chatStream.continueChatResult.requestId ?? "",
                        citations: event.data.chatStream.continueChatResult.message.citations,
                        annotations: annotations,
                        resourceId: event.data.chatStream.continueChatResult.resourceId,
                        citationDisplayType: event.data.chatStream.continueChatResult.message
                            .citationDisplayType ?? "",
                    };
                    if (annotations) {
                        for (let index = 0; index < annotations?.length; index++) {
                            const annotation = annotations[index];
                            assistantObj = {
                                ...assistantObj,
                                content: assistantObj?.content?.replace(annotation?.text, annotation?.text + `<sup>${index}</sup>`),
                            };
                        }
                    }
                    return assistantObj;
                };
                let streamedresponse = {
                    role: "assistant",
                    content: "",
                    id: uuidv4(),
                };
                if (event.data.chatStream.continueChatResult.message.content.includes("WaitMessage: ")) {
                    streamedresponse.content = extractWaitMessage(event.data.chatStream.continueChatResult.message.content + "\n\n");
                    // !dont know about this case for now
                    //@ts-ignore
                    const thinkingStatusMessage = {
                        messageType: "loading",
                        message: "",
                        messageId: requestId,
                        time: new Date(),
                        isThinking: true,
                        thinkingResponse: streamedresponse,
                        isStreamEnd: event?.data?.chatStream?.continueChatResult?.isEnd || false,
                    };
                    mfApi.dispatch(MF_EVENTS.PROCESS_STATUS, thinkingStatusMessage);
                }
                else {
                    streamedresponse.content = replaceAsteriskInAnchor(event.data.chatStream.continueChatResult.message.content)?.replace(/WaitMessage: /g, "");
                    const assistantObject = getAssistantObj(event, accordianMessageArray);
                    // thinking part
                    // console.log("assistantObject->>>>>", assistantObject);
                    //TODO status update from here
                    const thinkingStatusMessage = {
                        messageType: "loading",
                        message: "",
                        messageId: assistantObject.requestId,
                        time: new Date(),
                        isThinking: true,
                        thinkingResponse: assistantObject,
                        isStreamEnd: event?.data?.chatStream?.continueChatResult?.isEnd || false,
                    };
                    mfApi.dispatch(MF_EVENTS.PROCESS_STATUS, thinkingStatusMessage);
                    if (event?.data?.chatStream?.continueChatResult?.isEnd) {
                        try {
                            const parsedWidgetTypeData = JSON.parse(event?.data?.chatStream?.continueChatResult?.message?.content);
                        }
                        catch (error) {
                            console.log(error, "error");
                        }
                        if (artifactstatus !== "") {
                            mfApi.dispatch(MF_EVENTS.PROCESS_STATUS, storedMessageForArtifact);
                            artifactstatus = "";
                        }
                        break; // to end the grapql call
                    }
                }
            }
        }
        catch (error) {
            console.error("Error in callJiraAgent:", error.message);
            setIsGraphQlError(true);
            setIsFilesFetched(true);
            // You might want to dispatch an error status message here
            const errorStatusMessage = {
                messageType: "error",
                message: "Failed to connect to jira agent",
                messageId: uuidv4(),
                time: new Date(),
                isReadyToPersist: true,
            };
            mfApi.dispatch(MF_EVENTS.PROCESS_STATUS, errorStatusMessage);
        }
        finally {
            // Cleanup WebSocket connection
            if (client) {
                try {
                    const socket = client?.socket;
                    await client.dispose();
                    if (socket) {
                        const socketState = ["CONNECTING", "OPEN", "CLOSING", "CLOSED"][socket.readyState] ||
                            "UNKNOWN";
                        console.log(`WebSocket state after dispose: ${socketState} (${socket.readyState})`);
                        if (socket.readyState === WebSocket.CLOSED) {
                            console.log("WebSocket connection closed successfully");
                        }
                        else {
                            console.warn(`WebSocket not fully closed. Current state: ${socketState}`);
                        }
                    }
                    else {
                        console.log("WebSocket connection disposal completed");
                    }
                }
                catch (error) {
                    console.error("Error during WebSocket cleanup:", error);
                }
            }
        }
    };
    useEffect(() => {
        const handleRemoteLoad = () => {
            setHostLoadedInfo({
                modeName: HOST_MODES["Jira Mode"],
                isLoaded: true,
            });
            // old code
            // setIsHostLoaded?.(true);
            if (mfApi && "setRemoteLoaded" in mfApi) {
                mfApi.setRemoteLoaded(true);
            }
        };
        const handleRemoteUnload = () => {
            setHostLoadedInfo({
                modeName: HOST_MODES["Jira Mode"],
                isLoaded: false,
            });
            // old code
            // setIsHostLoaded?.(false);
            if (mfApi && "setRemoteLoaded" in mfApi) {
                mfApi.setRemoteLoaded(false);
            }
        };
        handleRemoteLoad();
        return () => {
            handleRemoteUnload();
        };
    }, [mfApi, setHostLoadedInfo]);
    useEffect(() => {
        if (!mfApi) {
            console.warn("Remote MicroFrontend API not initialized");
            return;
        }
        const unsubscribers = [];
        //NOTE: MAKE SURE EVENT NAME IS SAME AS THE `modeName` WHICH IS SET IN THE intialModeList.
        const unsubscribe = mfApi.subscribe(HOST_MODES["Jira Mode"], (request) => {
            console.log("Jira Tool Host Mode received request:", request);
            setUserEmail(request.userEmail ?? "");
            setQuery(request.message);
            //call jira agent
            callJiraAgent(request);
        });
        unsubscribers.push(unsubscribe);
        const getArtifaceDataUnsubscribe = mfApi.subscribe(MF_EVENTS.SEND_ARTIFACT_DATA, async (request) => {
            console.log("Jira Tool Host Mode received SEND_ARTIFACT_DATA request:", request);
            setShowErrorScreen(false);
            clearSelectedFiles();
            setShowWelComeScreen(false);
            setJiraTickets(request.artifactData);
            setIsFilesFetched(true);
        });
        unsubscribers.push(getArtifaceDataUnsubscribe);
        const subModeTriggerInDrive = mfApi.subscribe(MF_EVENTS.TRANSFER_SUBMODE_REQUEST, (request) => {
            console.log("Drive Tool Host Mode received TRANSFER_SUBMODE_REQUEST request:", request);
            // setSubModeRequest(request);
            if (request.eventType === "modeToTrigger" && request.data) {
                const messagePayload = {
                    message: request.data.modeToTrigger.query,
                    messageId: uuidv4(),
                    userEmail: user?.email,
                };
                callJiraAgent(messagePayload, request.data.modeToTrigger.additionalData);
            }
        });
        unsubscribers.push(subModeTriggerInDrive);
        return () => {
            unsubscribers.forEach((unsubscribe) => unsubscribe());
        };
    }, []);
    const handleAddToProject = () => {
        if (mfApi) {
            const payload = {
                addToProject: true, //!modeFullScreen,
                modeName: "Jira Mode",
            };
            mfApi.dispatch(MF_EVENTS.ADD_TO_PROJECT, payload);
        }
    };
    const count = 100; // Number of times to repeat
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    const sortOptions = [
        { label: "Name: A-Z", value: "asc" },
        { label: "Name: Z-A", value: "desc" },
    ];
    // Filter and sort logic
    // const filteredAndSortedFiles = useMemo(() => {
    //   const lowerSearchTerm = searchTerm.toLowerCase();
    //   // const filteredFiles = jiraTickets.filter((file: any) => {
    //   //   return file.name.toLowerCase().includes(lowerSearchTerm);
    //   // });
    //   const filteredFiles = jiraTickets;
    //   const filteredAndSortedFiles = jiraTickets;
    //   return filteredFiles.sort((a: any, b: any) => {
    //     switch (sortOrder) {
    //       case "asc":
    //         return a.name.localeCompare(b.name); // A-Z
    //       case "desc":
    //         return b.name.localeCompare(a.name); // Z-A
    //       default:
    //         return 0;
    //     }
    //   });
    // }, [jiraTickets, searchTerm, sortOrder]);
    // console.log("filteredAndSortedFiles", filteredAndSortedFiles);
    const handleFileClick = (e, project) => {
        if (scrollContainerRef.current) {
            setScrollPosition(scrollContainerRef.current.scrollTop);
        }
        const target = e.target;
        const isFileIconClick = target.closest(".file-icon");
        if (isFileIconClick) {
            setSelectedPreviewFile(project);
        }
        else {
            const isSelected = isFileSelected(project.id);
            if (!project.capabilities.canDownload) {
                showToast("warn", "Warn", "Cannot select file: Download permission not available");
                return;
            }
            handleSelectProject(project, !isSelected);
        }
    };
    useEffect(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = scrollPosition;
        }
    }, [scrollPosition, selectedFiles]);
    if (isGraphqlError === true && showWelcomeScreen === false) {
        return (_jsxs("div", { className: "mt-20 flex flex-col justify-center items-center", children: [_jsx(Lottie, { animationData: NotFoundAnimation, loop: true, play: true, className: "w-full md:w-1/2 mx-auto" }), _jsx("p", { className: "italic text-red-500", children: "There is some error occurred, please try again..." })] }));
    }
    if (showWelcomeScreen) {
        return _jsx(JiraWelcomeScreen, {});
    }
    if (isFilesFetched === false &&
        isGraphqlError === false &&
        showWelcomeScreen === false &&
        showErrorScreen === false) {
        return _jsx(LoadingAnimation, {});
    }
    if (showErrorScreen) {
        return _jsx(JiraErrorScreen, {});
    }
    // const [searchTerm, setSearchTerm] = useState('');
    // Filter tickets based on search term
    const filteredTickets = jiraTickets?.filter((ticket) => ticket.issue_key.toLowerCase().includes(searchTerm.toLowerCase()) ||
        ticket.issue_fields.summary
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
        ticket.issue_fields.assignee
            .toLowerCase()
            .includes(searchTerm.toLowerCase()));
    // Get priority class
    const getPriorityClass = (priority) => {
        switch (priority.toLowerCase()) {
            case "high":
                return "bg-red-500";
            case "medium":
                return "bg-orange-500";
            case "low":
                return "bg-green-500";
            default:
                return "bg-blue-500";
        }
    };
    // Get issue type icon
    const getIssueTypeIcon = (type) => {
        switch (type.toLowerCase()) {
            case "bug":
                return _jsx(Bug, { size: 18, className: "text-red-500" });
            default:
                return _jsx(AlertCircle, { size: 18, className: "text-purple-500" });
        }
    };
    // Format date to more readable format
    const formatDate = (dateString) => {
        if (!dateString)
            return "";
        const date = new Date(dateString);
        const now = new Date();
        const diffDays = Math.floor((now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24));
        if (diffDays === 0) {
            return "Today";
        }
        else if (diffDays === 1) {
            return "Yesterday";
        }
        else if (diffDays < 7) {
            return `${diffDays} days ago`;
        }
        else {
            return date.toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
            });
        }
    };
    if (hasNeededScope && hasNeededScope === "invalid") {
        return _jsx(InvalidScopes, { scopeName: "Jira" });
    }
    return (_jsxs("div", { className: "p-6 flex flex-col gap-y-5 h-full w-full", children: [_jsxs("div", { className: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4 w-full", children: [_jsx("div", { className: "flex flex-col items-start", children: _jsxs("div", { className: "flex items-center gap-2 mb-2 flex-shrink-0", children: [_jsx(JiraIcon, {}), _jsxs("div", { className: "flex gap-2 items-center", children: [_jsx("h2", { className: "text-3xl h-lg:text-4xl bg-gradient-to-br from-[#2546F0] to-[#5928ED] bg-clip-text text-transparent font-heading font-semibold", children: "Jira Tickets" }), _jsx("span", { className: "text-sm text-black font-heading font-semibold", children: "Powered by Agentspace" })] })] }) }), _jsxs("div", { className: "relative w-[300px]", children: [_jsx("input", { type: "text", value: searchTerm, onChange: (e) => setSearchTerm(e.target.value), placeholder: "Search tickets...", className: "w-full text-sm rounded-[6px] pl-10 pr-4 py-2 bg-white border border-[#d1d5db] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" }), _jsx(Search, { className: "absolute left-3 top-2.5 text-gray-400", size: 18 })] })] }), _jsx("div", { className: "flex flex-col gap-y-4 w-full h-[calc(100%-4rem)] overflow-y-auto", children: filteredTickets.length > 0 ? (filteredTickets.map((ticket) => (_jsxs("div", { className: "bg-white flex-shrink-0 rounded-[8px] transition-all duration-200 overflow-hidden border border-[#E1E5EB]", children: [_jsx("div", { className: "flex items-center justify-between px-4 py-3 border-b border-gray-100", children: _jsxs("div", { className: "flex items-center gap-3", children: [_jsx("div", { onClick: () => {
                                            window.open(ticket.issue_url, "_blank", "noopener,noreferrer");
                                        }, className: "flex-shrink-0 cursor-pointer", children: getIssueTypeIcon(ticket.issue_fields.issuetype) }), _jsxs("div", { children: [_jsx("div", { onClick: () => {
                                                    window.open(ticket.issue_url, "_blank", "noopener,noreferrer");
                                                }, className: "flex items-center gap-2 cursor-pointer", children: _jsx("span", { className: "font-mono text-sm font-medium text-[#5928ed]", children: String(ticket.issue_key) }) }), _jsx("h3", { onClick: () => {
                                                    window.open(ticket.issue_url, "_blank", "noopener,noreferrer");
                                                }, className: "cursor-pointer font-semibold text-lg text-[#101828]", children: _jsx("span", { children: ticket.issue_fields.summary }) })] })] }) }), _jsxs("div", { className: "px-4 py-3 bg-gray-50/50", children: [_jsxs("div", { className: "flex flex-wrap gap-x-6 gap-y-2 text-sm", children: [_jsxs("div", { className: "flex items-center gap-1", children: [_jsx(User, { size: 14, className: "text-gray-500" }), _jsx("span", { className: "text-gray-500", children: "Assignee:" }), _jsx("span", { className: "font-medium text-[#344054]", children: ticket.issue_fields.assignee })] }), _jsxs("div", { className: "flex items-center gap-1", children: [_jsx(Calendar, { size: 14, className: "text-gray-500" }), _jsx("span", { className: "text-gray-500", children: "Created:" }), _jsx("span", { className: "font-medium text-[#344054]", children: formatDate(ticket.issue_fields.created) })] }), _jsxs("div", { className: "flex items-center gap-1", children: [_jsx("span", { className: "text-gray-500", children: "Priotiy:" }), _jsx("span", { className: "font-medium text-[#344054]", children: ticket.issue_fields.priority })] }), ticket.issue_fields.labels &&
                                            ticket.issue_fields.labels.length > 0 && (_jsxs("div", { className: "flex items-center gap-2 ml-auto", children: [_jsx("span", { className: "text-gray-500", children: "Labels:" }), _jsx("div", { className: "flex flex-wrap gap-1", children: ticket.issue_fields.labels.map((label, index) => (_jsx("span", { className: "px-3 py-0.5 bg-indigo-100 text-indigo-800 rounded-full text-xs", children: label }, index))) })] }))] }), ticket.issue_fields.description && (_jsx("div", { className: "mt-3 text-sm text-gray-600 border-t border-gray-200 pt-3", children: _jsxs("div", { className: "relative", children: [_jsx(ReactMarkdown, { className: `text-sm font-medium text-gray-500 ${isDescriptionExpanded ? "" : "line-clamp-2"}`, children: typeof ticket.issue_fields.description === "string"
                                                    ? ticket.issue_fields.description
                                                    : String(ticket.issue_fields.description) }), ticket.issue_fields.description && (_jsx("button", { onClick: toggleDescription, className: "absolute bottom-0 right-0 flex items-center text-xs text-blue-600 hover:text-blue-800 bg-white pl-1 cursor-pointer", children: isDescriptionExpanded ? (_jsx(_Fragment, { children: _jsx(ChevronUp, { size: 14, className: "ml-1" }) })) : (_jsx(_Fragment, { children: _jsx(ChevronDown, { size: 14, className: "ml-1" }) })) }))] }) }))] })] }, String(ticket.issue_key))))) : (_jsxs("div", { className: "bg-white border border-gray-200 rounded-xl p-8 text-center", children: [_jsx("div", { className: "w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center", children: _jsx(Search, { className: "text-gray-400", size: 24 }) }), _jsx("h3", { className: "text-gray-800 font-medium text-lg mb-1", children: "No tickets found" }), _jsx("p", { className: "text-gray-500", children: "Try adjusting your search criteria" })] })) })] }));
};
export default JiraModeTool;
